var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "password-input-wrapper" }, [
    _c("input", {
      staticClass: "password-input",
      attrs: {
        id: _vm.id,
        type: _vm.showPassword ? "text" : "password",
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        autocomplete: "new-password",
      },
      domProps: { value: _vm.value },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event.target.value)
        },
        focus: function ($event) {
          return _vm.$emit("focus")
        },
        blur: function ($event) {
          return _vm.$emit("blur")
        },
      },
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "password-toggle",
        attrs: {
          type: "button",
          disabled: _vm.disabled,
          "aria-label": _vm.showPassword ? "Hide password" : "Show password",
        },
        on: { click: _vm.togglePasswordVisibility },
      },
      [_c("i", { class: _vm.showPassword ? "fas fa-eye-slash" : "fas fa-eye" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }